export default __webpack_public_path__ + "static/kdc-seal-white-b670450aaafd1e3429abd78d4a251897.png";